import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './resetNewPwd.module.scss';
import utils from '../../utils/utils';
import { Button } from 'antd-mobile-v5';
import { InputItem } from 'antd-mobile';
import  { ApiCore } from '../../api/index';
import {  Toast } from 'antd-mobile';
import methods from '../../utils/methods';
import { Encrypt, Decrypt } from '../../utils/crypto';
const api = new ApiCore();
function ResetNewPwd(props: any) {

    // 手机号
    const [phone, setPhone] = useState('');
    // 密码
    const [password, setPassword] = useState('');
    // 确认密码
    const [passwordAgain, setPasswordAgain] = useState('');
    // 是否隐藏
    const [isOpen, setIsOpen] = useState('');
    // 是否隐藏
    const [isValidPwd, setIsValidPwd] = useState(false);

    useEffect(() => {
        document.title = '重置密码';

        if (props.location.params && props.location.params.phone) {
            setPhone(props.location.params.phone)
        } else {
            let info = sessionStorage.getItem('phoneInfo')

            if (info) {
                let phoneInfo = JSON.parse(info)
                setPhone(phoneInfo.phone)
            }

        }

    }, [])

    //当密码发生改变
    const passwordChange = (value: any) => {
        setPassword(value);
        if (value && passwordAgain) {
            setIsValidPwd(true);
        }
    }

    // 确认密码
    const passwordChangeAgain = (value: any) => {
        setPasswordAgain(value)
        if (value && password) {
            setIsValidPwd(true);
        }
    }

    // 跳转至于完成页
    const toHome= () => {
        if (!password) {
            Toast.fail('请先输入密码！', 0.8);
            return
        }
        if (!passwordAgain) {
            Toast.fail('请重复输入密码！', 0.8);
            return
        }
        if (!methods.verifyPassWordEighteen(password) || password.length < 6 || password.length > 20) {
            Toast.fail('密码为6-18位的数字和字母的组合！', 0.8);
            return;
        }
        if (password !== passwordAgain) {
            Toast.fail('密码不一致，请重新输入！', 0.8);
            return;
        }
        let pwdCode = sessionStorage.getItem('ResetNewPdwCode');
        api.ToResetNewPassword({
            newPass: Encrypt(passwordAgain),
            refreshCode: pwdCode,
            resetType: 'SMS'
        }).then((res: any) => {
            if (res.code == 0) {
                props.history.push('/doctor/resetPwdComplete');
            } else {
                Toast.fail(res.message || '重置失败');
            }
        });
    }


    return (
        <div className={`${styles.resetNewPassword_content}`}>
            <div className={styles.passWord_login}>
                <div className={styles.InputItemWrap}>
                    <div className={styles.InputItemContent}>
                        <label className={styles.label}>设置密码</label>
                        <InputItem
                            type={!isOpen ? 'password' : 'text'}
                            placeholder={'6-18位数字/字母组合'}
                            maxLength={18}
                            minLength={6}
                            value={password}
                            onChange={passwordChange}
                        />
                    </div>
                </div>
                <div className={styles.InputItemWrap}>
                    <div className={styles.InputItemContent}>
                        <label className={styles.label}>重复输入密码</label>
                        <InputItem
                            type={!isOpen ? 'password' : 'text'}
                            placeholder={'请重新输入一遍您设置的密码'}
                            maxLength={18}
                            minLength={6}
                            value={passwordAgain}
                            onChange={passwordChangeAgain}
                        />
                    </div>
                </div>
                <Button className={`${styles.complete_btn}`} disabled={!isValidPwd} color='primary' onClick={() => { toHome() }}>完成</Button>
            </div>
        </div>
    )

}

export default ResetNewPwd;